<template>
    <div class="info-request" :data-type="infoType">
        <div v-if="!isSuccess" class="form" data-type="modal">
            <div class="top">
                <h1 class="title"> {{ localizer.get("Coupon.Common.Coupon_Title") }}</h1>
                <h2 class="abstract">{{ localizer.get("Coupon.Common.Coupon_Abstract") }}</h2>
            </div>
            <div class="content">
                <fieldset class="fieldset" data-width="50%" :disabled="isLoading">
                    <div class="item">
                        <div class="control">
                            <label class="label" for="NameSurname">{{ localizer.get("Coupon.Common.NameSurname") }}</label>
                            <input type="text" id="NameSurname" name="NameSurname" v-model.lazy="formData.nameSurname" :class="[{ 'input-validation-error': isValidationError('NameSurname') }, 'textbox']" />
                        </div>
                    </div>
                    <div class="item">
                        <div class="control">
                            <label class="label" for="Phone">{{ localizer.get("Coupon.Common.Phone") }}</label>
                            <input type="tel" id="Phone" v-model.lazy="formData.phone" :class="[{ 'input-validation-error': isValidationError('Phone') }, 'textbox']" />
                        </div>
                    </div>
                    <div class="item">
                        <div class="control">
                            <label class="label" for="Email">{{ localizer.get("Coupon.Common.Email") }}</label>
                            <input type="email" id="Email" v-model.lazy="formData.email" :class="[{ 'input-validation-error': isValidationError('Email') }, 'textbox']" />
                        </div>
                    </div>
                    <div class="item">
                        <div class="control">
                            <label class="label" for="Company">{{ localizer.get("Coupon.Common.Company") }}</label>
                            <input type="text" id="Company" v-model.lazy="formData.company" :class="[{ 'input-validation-error': isValidationError('Company') }, 'textbox']" />
                        </div>
                    </div>
                    <div class="item" data-lable="top">
                        <div class="control">
                            <label class="label" for="">{{ localizer.get("Coupon.Common.Message") }}</label>
                            <textarea type="text" id="Message" v-model.lazy="formData.message" rows="3" cols="15" :class="[{ 'input-validation-error': isValidationError('Message') }, 'textarea']"></textarea>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="fieldset" data-width="50%">
                    <div class="item">
                        <div class="checkbox">
                            <input type="checkbox" id="isPrivacyPolicy" v-model="formData.isPrivacyPolicy" />
                            <label for="isPrivacyPolicy">{{ localizer.get("Coupon.Common.PrivacyDisclaimer_Text") }}</label> <a class="link" :href="routes.Terms_PrivacyPolicy" target="_blank">{{ localizer.get("Coupon.Common.PrivacyDisclaimer_Button") }}</a>
                        </div>
                    </div>
                </fieldset>
                <fieldset class="fieldset" data-width="50%">
                    <div v-if="validationErrors.length !== 0" class="validation-summary-errors">
                        <ul>
                            <li v-for="(validationError, index) in validationErrors" :key="index">{{ validationError.message }}</li>
                        </ul>
                    </div>
                    <div class="form-items" data-type="buttons">
                        <div class="item calltoaction" data-size="big">
                            <button @click="submitForm()" class="button" :disabled="isLoading"><span class="lable">{{ localizer.get("Coupon.Common.Send") }}</span></button>
                        </div>
                    </div>
                    <div class="item">
                        <div class="captcha-terms" v-html="localizer.get('App.Recaptcha.CaptchaTerms')"></div>
                    </div>
                </fieldset>

                <img src="/images/info-request-big.png" width="629" height="700" alt="Technical Ceramic" class="image" loading="lazy" />
            </div>
        </div>
        <div v-else class="success-box">
            <div class="page-content">
                <div class="title">{{ localizer.get("Coupon.Common.Success_Title") }}</div>
                <div class="abstract mrg" data-mrgb="30">{{ localizer.get("Coupon.Common.Success_Text") }}</div>
                <div class="calltoaction mrg" data-mrgt="20">
                    <div class="button" data-color="green" @click="closeDialog()">{{ localizer.get("Coupon.Common.ContinueNavigation") }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, onMounted, nextTick } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";
import ResponsiveHelper from "@Scripts/Infrastructure/ResponsiveHelper";

const props = defineProps<{
    recaptchaSiteKey?: string,
    isDialog?: string,
    infoType?: string
}>();

const localizer = Localizer;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const formData = ref<any>({});
const validationErrors = ref<any[]>([]);

onMounted(() => {
    ResponsiveHelper.onResize();
});

async function submitForm() {
    FormHelper.removeFocus();

    validationErrors.value = [];

    isLoading.value = true;

    formData.value.originPage = window.location.href;

    (window as any).grecaptcha.enterprise.ready(async () => {
        const token = await (window as any).grecaptcha.enterprise.execute(props.recaptchaSiteKey, { action: 'Submit' });

        try {
            await Axios.post(routes.Support_InfoRequest, formData.value, { headers: { "RecaptchaVerificationToken": token } });

            isSuccess.value = true;

            GTagHelper.sendEvent("form_submit", "info_request");
        } catch (error: any) {
            if (error.response && error.response.status === 400) {
                validationErrors.value = FormHelper.getValidationErrors(error.response.data);
            }
        }

        isLoading.value = false;
    });
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

function closeDialog() {
    if ((<any>parent).$.fancybox.getInstance()) {
        nextTick(() => {
            (<any>parent).$.fancybox.getInstance().close(false);
        });
    }
}
</script>
